import { GrcNotify, NotifyType } from '@grc/ui-package';
import { orderService } from '@grc/ui-shared/lib/components/common/constants/constants';
import { fetchMyWorkItemsDetails } from '../../common/constants/url-constants';
import { IShipmentGridRow } from '../../models/shipments/shipment-grid-row.interface';

// Each call gets its own request/promise rather than being deduped by params across callers:
// fetchData's cancellation (useGetApiData) is scoped to the calling component's lifecycle, so
// sharing one promise across independent mounts (e.g. React StrictMode's intentional
// mount->cleanup->remount cycle) let an unrelated mount's cancellation resolve to an empty
// result for a still-live caller, which is why the grid never populated.
export const GetMyWorkItemsDetails = async (
  fetchData: any,
  params: Record<string, unknown>
): Promise<IShipmentGridRow[]> => {
  try {
    const response = await fetchData(
      fetchMyWorkItemsDetails,
      (message: string) => GrcNotify({ message, status: NotifyType.Error }),
      orderService,
      params
    );
    const data = response?.data;
    return (Array.isArray(data) ? data : data?.items ?? []) as IShipmentGridRow[];
  } catch (error: any) {
    GrcNotify({ message: error.message, status: NotifyType.Error });
    return [] as IShipmentGridRow[];
  }
};

export default GetMyWorkItemsDetails;
